import { usePageContext } from "vike-react/usePageContext";

/**
 * Replacement for react-router's useParams().
 * Returns route parameters from Vike's page context.
 */
export function useRouteParams<T extends Record<string, string> = Record<string, string>>(): T {
  const pageContext = usePageContext();
  return (pageContext.routeParams || {}) as T;
}
